import { Typography } from "@mui/material";
import React from "react";
import { get_app_logo, s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";

export default function GroupsFeeds({ data }) {
  const { selectedGroup, setSelectedGroup } = useContentSetting();

  const handleGroupFeed = (value) => {
    localStorage.setItem("selectedGroup", value?._id || "general");
    setSelectedGroup(value?._id || "");
  };
  const logo = get_app_logo();

  return (
    <>
      <div className="community-left-sidebar">
        <div
          className="row profile-cards"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <div className="col-12">
            <h3 className="groups-text">General Community</h3>
          </div>
          <div className="col-12 mb-2">
            <div
              className="group-card"
              style={{
                backgroundColor: !selectedGroup ? "#04abbb17" : "#fff",
              }}
              onClick={() => handleGroupFeed("")}
            >
              <div className="card-body">
                <div className="row">
                  <div className="col-3  d-flex align-items-center">
                    <img
                      width={40}
                      height={40}
                      src={logo}
                      alt="Group Image"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div className="col-8 d-flex align-items-center">
                    <p
                      className="card-title groups-text-feeds"
                      style={{
                        color: !selectedGroup ? "#000" : "#04abbb",
                      }}
                    >
                      General Community
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <h3 className="groups-text">Groups</h3>
          </div>
          {data && data.length > 0 ? (
            <>
              {data.map((item, index) => {
                let selected_border = selectedGroup === item._id;
                return (
                  <div className="col-12 mb-2" key={index}>
                    <div
                      className="group-card"
                      style={{
                        backgroundColor: selected_border ? "#04abbb17" : "#fff",
                      }}
                      onClick={() => handleGroupFeed(item)}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-3  d-flex align-items-center">
                            <img
                              width={40}
                              height={40}
                              src={s3baseUrl + item?.image?.thumbnail_1}
                              alt="Group Image"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                          <div className="col-8 d-flex align-items-center">
                            <p
                              className="card-title groups-text-feeds"
                              style={{
                                color: selected_border ? "#000" : "#04abbb",
                              }}
                            >
                              {item.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <Typography
              variant="h5"
              align="center"
              style={{ marginBottom: 10, marginTop: 10 }}
              justifyContent="center"
            >
              No Groups Available
            </Typography>
          )}
        </div>
      </div>
    </>
  );
}
